"use client";

import { memo } from "react";
import { HeroLight } from "@/components/screen/global-components/hero";

const AffiliateHero = ({}: React.ComponentProps<"section">) => {
  return (
    <HeroLight
      title="Affiliate translate partner program"
      description="Join Languex’ free affiliate program to promote Languex and receive 25% revenue on referrals. Email our support team to get your tracking link today."
      primaryButton={{
        href: "#",
        label: "Join Now",
      }}
      descriptionClassName="lg:max-w-[585] lg:mx-auto"
    />
  );
};

export default memo(AffiliateHero);
